import { useState, useEffect } from "react";

export function useFetch({ queryFn, queryKeys = [], enabled = true }) {
  const [data, setData] = useState(null);
  const [isFetching, setIsFetching] = useState(false);
  const [error, setError] = useState(null);

  const fetchData = async () => {
    if (!enabled) return;

    setIsFetching(true);
    try {
      const result = await queryFn();
      console.log("result >>", result);
      setData(result);
    } catch (error) {
      setError(error);
    } finally {
      setIsFetching(false);
    }
  };

  useEffect(() => {
    setIsFetching(true);
    fetchData();
  }, queryKeys);

  return { data, isFetching, error, refetch: fetchData };
}
